import gemImage from "../assets/images/gem.png"
import useBuyTx from "../hooks/useBuyTx"
import {modalType} from "./Modal"
import {DECLINE_RESPONSE} from "../constants"
import {useClientContext} from "../contexts/ClientContext"


export default function StoreItem({price, description}) {
    const {frgBalance, updateFRGBalance, setModalData, setShowModal} = useClientContext()
    const [state, buyStoreItem] = useBuyTx(
        () => {
            updateFRGBalance()
            setModalData({
                type: modalType.Info,
                title: "Success!",
                message: `Congrats, you have purchased ${description}`
            })
            setShowModal(true)
        },
        (err) => {
            if (err === DECLINE_RESPONSE) {
                setModalData({
                    type: modalType.Error,
                    title: "Transaction Declined",
                    message: "Oops, it looks like you chose to decline this transaction."
                })
            } else {
                setModalData({type: modalType.Error, title: "Error", message: err})
            }
            setShowModal(true)
        })

    const disabled = frgBalance < price

    const enabledStyle = "bg-fr-pink hover:border-white"
    const disabledStyle = "bg-fr-pink opacity-20"

    const doBuy = async () => {
        buyStoreItem(price)
    }

    return (
        <>
            <div>
                <button
                    onClick={doBuy}
                    className={`font-pinwy text-2xl uppercase flex px-4 py-2 my-2 border-4 border-gray-700 rounded-md text-white items-center w-40 ${disabled ? disabledStyle : enabledStyle}`}
                    disabled={disabled}>
                    <img src={gemImage} className={'h-8'} alt={''}/>
                    <div className={'pl-4'}>{price}</div>
                </button>
            </div>
            <div className={"font-pixellari text-gray-400 my-auto"}>{description}</div>
        </>
    )
}